import React, { useState } from "react";
import { useAppContext } from "../hooks/useAppContext";
import { getTranslation } from "../locales/getTranslation";
import sidebarTranslation from "../locales/sidebar.json";

type ModalDeleteProps = {
  deleteChat?: () => Promise<void> | void;
  setOpenDeleteModal: React.Dispatch<React.SetStateAction<boolean>>;
};

const ModalDelete = ({ deleteChat, setOpenDeleteModal }: ModalDeleteProps) => {
  const { locale } = useAppContext();
  const [isDeleting, setIsDeleting] = useState(false);

  const handleDelete = async () => {
    if (!deleteChat || isDeleting) return;
    setIsDeleting(true);
    try {
      await deleteChat();
    } finally {
      setIsDeleting(false);
      setOpenDeleteModal(false);
    }
  };

  return (
    <div className="flex flex-col items-center justify-center gap-[20px] rounded-[28px] bg-grayscale-solid-elevate-level1 p-8 shadow md:gap-[32px] md:rounded-[32px] md:p-12">
      <div className="flex flex-col items-center justify-center gap-[14px]">
        <h1 className="text-center text-sm font-medium leading-[150%] text-grayscale-solid-g10 md:text-[16px] lg:text-[20px]">
          {getTranslation(locale, "Delete Conversation Confirmation")}
        </h1>
      </div>
      <hr className="h-[1px] w-full border-[1px] border-[#EBEBEE]" />
      <div className="flex items-center justify-center gap-[6px]">
        <button
          className="flex items-center gap-2 rounded-xl px-4 py-[6px] text-[12px] font-medium text-grayscale-solid-g10 outline outline-1 outline-offset-[-1px] outline-grayscale-opacity-blevel4 transition-colors hover:bg-red-solid-red6 hover:text-grayscale-solid-fixed-white hover:outline-0 disabled:cursor-not-allowed disabled:opacity-50 md:px-6 md:py-[8px] md:text-[14px] lg:px-6 lg:py-[8px]"
          onClick={handleDelete}
          disabled={isDeleting}
        >
          {isDeleting && (
            <svg
              className="h-3 w-3 animate-spin"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
            >
              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
            </svg>
          )}
          {sidebarTranslation["Delete"][locale]}
        </button>
        <button
          className="rounded-xl px-4 py-[6px] text-[12px] font-medium text-grayscale-solid-g10 outline outline-1 outline-offset-[-1px] outline-grayscale-opacity-blevel4 transition-colors hover:bg-blue-solid-blue6 hover:text-grayscale-solid-fixed-white hover:outline-0 disabled:cursor-not-allowed disabled:opacity-50 md:px-6 md:py-[8px] md:text-[14px] lg:px-6 lg:py-[8px]"
          onClick={() => setOpenDeleteModal(false)}
          disabled={isDeleting}
        >
          {sidebarTranslation["Cancel"][locale]}
        </button>
      </div>
    </div>
  );
};

export default ModalDelete;
